module.exports = "/static/media/BuoyantBop.fe55146c.wav";